import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { ProdutosSend } from '../_model/produtos';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProdutosService {

constructor(private http: HttpClient) { }

baseUrl: string = "https://"+environment.apiUrl+"/api/produtos/";

list() {
  return this.http.post(this.baseUrl+"list", null)
    .pipe(
      map((data: any) => {
        return data.result;
      })
    );
}

getRawMedia(id: number) {
  return this.http.post(this.baseUrl+"media/"+id, null)
    .pipe(
      map((data: any) => {
        return data.result;
      })
    );
}

send(model: ProdutosSend) {
  return this.http.post(this.baseUrl+"input", model).pipe();
}

delete(id: number, userId: string) {
  return this.http.post(this.baseUrl+"delete/"+id,{id: userId}).pipe();
}

get(id: number) {
  return this.http.post(this.baseUrl+"get/"+id, null).pipe(
    map((data: any) => {
      return data.result;
    })
  );
}

}
